var render, staticRenderFns
import script from "./main.vue?vue&type=script&lang=jsx&"
export * from "./main.vue?vue&type=script&lang=jsx&"
import style0 from "./main.vue?vue&type=style&index=0&id=eddcf996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddcf996",
  null
  
)

export default component.exports